// @ts-nocheck
import * as React from "react";

const ReorderLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M8.56 19.461a1.5 1.5 0 1 1-2.12 2.122 1.5 1.5 0 0 1 2.12-2.122Zm10 0a1.5 1.5 0 1 1-2.12 2.122 1.5 1.5 0 0 1 2.12-2.122ZM5 4.022a1 1 0 0 1 1 .74l.58 2.26h4.441a6.5 6.5 0 0 0 .489 2H7.13l1.63 6h7.62L17.391 13a6.506 6.506 0 0 0 2.455-.437l-1.956 3.91a1 1 0 0 1-.89.55H8a1 1 0 0 1-1-.74L4.24 6.022H3a1 1 0 1 1 0-2h2Zm14.532-1.488.25.156a4.613 4.613 0 0 1 1.597 1.843l.065.146-.007-.016.219-.253c.173-.201.44-.285.694-.227l.108.033.1.05.096.07c.296.255.33.702.075.998l-1.28 1.49-.044.036-.032.013-.047.053-.064.042-.043.015-.021.004-.041.018-.11.035a.537.537 0 0 1-.116.007l-.025-.007-.021.003-.07-.006a.702.702 0 0 1-.229-.083l-.098-.06-1.584-1.3a.7.7 0 0 1 .712-1.19l.035.017-.047-.057a3.235 3.235 0 0 0-.362-.339l-.2-.148-.217-.136A3.16 3.16 0 0 0 14.5 4.836a3.162 3.162 0 0 0 1.214 4.3 3.18 3.18 0 0 0 3.745-.367.7.7 0 0 1 .985.045l.084.104a.701.701 0 0 1-.108.894 4.568 4.568 0 0 1-5.405.535 4.561 4.561 0 0 1-1.727-6.21 4.561 4.561 0 0 1 6.243-1.603Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ReorderLine);
